<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import AutomationOutbox from './automation-outbox.svelte'
    import AutomacaoManager from './automacao-manager.svelte'
    import AudienceManager from './audience/audience-manager.svelte'
    import AutomacaoCreatives from './automacao-creatives.svelte'
    import ProvidersManager from './providers/providers-manager.svelte'

    let tabs = []
    if (window.store.token.permissions.marketing.marketing.read) {
        tabs.push({
            title: 'Automações',
            url: '/automation/automations',
        })
    }
    if (window.store.token.permissions.marketing.audience.read) {
        tabs.push({
            title: 'Públicos',
            url: '/automation/audience',
        })
    }
    if (window.store.token.permissions.marketing.templates.read) {
        tabs.push({
            title: 'Templates',
            url: '/automation/templates',
        })
    }
    if (window.store.token.permissions.marketing.providers.read) {
        tabs.push({
            title: 'Provedores',
            url: '/automation/providers',
        })
    }

    if (window.store.token.permissions.marketing.outbox.read) {
        tabs.push({
            title: 'Caixa de saída',
            url: '/automation/outbox',
        })
    }
</script>

<div class="root-content">
    <Ztab class="h-space" {tabs} />
    <Router>
        <Route path="/automations">
            <AutomacaoManager />
        </Route>
        <Route path="/audience">
            <AudienceManager />
        </Route>
        <Route path="/templates">
            <AutomacaoCreatives />
        </Route>
        <Route path="/providers">
            <ProvidersManager />
        </Route>
        <Route path="/outbox">
            <AutomationOutbox />
        </Route>
    </Router>
</div>
